import { useCallback } from 'react';
import { useAppDispatch } from '../../useReduxToolkit';
import * as realtime from '../../../features/realtime/realtime.slice';
import { RealtimeRole } from '../../../features/realtime/realtime.types';
import { useProviderActions } from '../../useProviderActions';
import { useCallParticipants } from '../../useCallParticipants';
/**
 * useCallHangUp hook is only called on one side either patient or provider
 * whoever ends the call. It is NOT called on provider side if patient ends the call and so.
 * @returns Promise<void>
 */
export const useUpdateRealtimeStateAfterHangUp = (): (() => Promise<void>) => {
  const dispatch = useAppDispatch();
  const { callParticipants } = useCallParticipants();
  const { removeParticipantsAfterCallHangUp } = useProviderActions();
  return useCallback(async (): Promise<void> => {
    const { role } = realtime.realtimeInstance.identity;

    /**
     * Tell the patients that the call should end gracefully.
     * Otherwise, they will assume the provider left unexpectedly and remain in the waiting room.
     * This way, they will check out automatically.
     */
    if (role === RealtimeRole.Provider) {
      await removeParticipantsAfterCallHangUp(
        callParticipants.map((participant) => participant.id),
      );

      // If returning to V2 dashboard, do not leave Realtime.
      return;
    }

    await dispatch(realtime.unsubscribe()).unwrap();
  }, [dispatch, callParticipants]);
};
